<template src="./AppFooterAttente.html"></template>
<style lang="scss" scoped src="./AppFooterAttente.scss"></style>

<script>
import {
  SfFooter,
  SfList,
  SfImage,
  SfMenuItem
} from '@storefront-ui/vue';
import {OrkSocial, OrkReassurance} from "@/components/Ork";
import {icons} from "@/utils/icons";

export default {
  components: {
    SfImage,
    SfFooter,
    SfList,
    SfMenuItem,
    OrkSocial,
    OrkReassurance
  },

  data() {
    return {
      isHome: '',
      social: [
        {
          label: 'facebook',
          link: 'http://www.facebook.com/pages/Air-France/10150136746870526?ref=ts',
          icon: icons.facebook
        },
        {
          label: 'instagram',
          link: 'http://instagram.com/airfrance',
          icon: icons.instagram
        },

        {
          label: 'pinterest',
          link: 'https://www.pinterest.fr/airfrance/',
          icon: icons.pinterest
        },
        {
          label: 'twitter',
          link: 'https://twitter.com/AirFrance',
          icon: icons.twitter
        },
        {
          label: 'linkedIn',
          link: 'http://www.linkedin.com/company/air-france',
          icon: icons.linkedIn
        },

        {
          label: 'youtube',
          link: 'https://www.youtube.com/airfranceonair',
          icon: icons.youtube
        },
      ],

      /*menuFooter1: [
        {
          title: this.$i18n.t('Q&A'),
          slug: '/faq',
          target: '_self'
        },
        {
          title: this.$i18n.t('Delivery'),
          slug: '/livraison',
          target: '_self'
        },
        {
          title: this.$i18n.t('Exchange / Return'),
          slug: '/echange-retour',
          target: '_self'
        },
        {
          title: this.$i18n.t('Contact us'),
          slug: '/contact',
          target: '_self'
        }
      ],*/
      menuFooter2: [
        {
          title: this.$i18n.t('Book a flight'),
          slug: 'https://www.airfrance.fr/',
          target: '_blank'
        },
        {
          title: this.$i18n.t('Flying Blue Program'),
          slug: 'https://www.airfrance.fr/FR/en/common/voyageurfrequent/flyingblue/discover-flying-blue.htm',
          target: '_blank'
        },
        /* {
           title: this.$i18n.t('Terms of use'),
           slug: '/conditions-generales-d-utilisation',
           target: '_self'
         },
         {
           title: this.$i18n.t('Legal mentions'),
           slug: '/mentions-legales',
           target: '_self'
         }*/
      ],
      isMobile: true,
      desktopMin: 768
    };
  },
  created() {
    this.isHomeFn()
  },
  watch: {
    $route: 'isHomeFn'
  },
  methods: {
    isHomeFn() {
      this.isHome = this.$router.history.current.name
    }
  }
};
</script>

